import Hospitalizations from './Hospitalizations';

export default Hospitalizations;
